// extracted by mini-css-extract-plugin
export default {"Container":"changingmodelwarning_Container__qsvqa"};